import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { Ionicons } from "@expo/vector-icons"
import { dateTimeFR, getReminderIcon, localDateFormat, removeTimeZone } from "@Utils/utils"
import moment from "moment"
import React from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"

export const ReminderCardItem = (props) => {
    const isEmptyArray = props?.recurrence?.recurrenceDays?.length === 0
    const getRecurrence = (recurrence, frequency) => {
        switch (recurrence) {
            case "day":
                return `jour${frequency > 1 ? "s" : ""}`
            case "week":
                return "semaine"
            case "month":
                return "mois"
            case "year":
                return "an"
            case "once":
                return ""
        }
    }

    const takeDateWithoutTimeZone = removeTimeZone(props?.deadline)
    const reminderDateTime = moment(takeDateWithoutTimeZone).format(localDateFormat).toString() + ` à ` + props?.time

    return (
        <TouchableOpacity onPress={() => props.onPress && props.onPress()} activeOpacity={0.6}>
            <View style={{ ...styles.container, backgroundColor: props.backgroundColor }}>
                <View style={{ flexDirection: "row" }}>
                    <View style={styles.iconContainer}>{getReminderIcon(props.type?.name)}</View>
                    <View style={styles.titleContainer}>
                        <OpenSansText fontSize={16} color={baseColors.white}>
                            {props.name}
                        </OpenSansText>
                        <Ionicons size={20} color={baseColors.white} name={"chevron-forward"} />
                    </View>
                </View>

                <Spacer height={10} />

                <OpenSansText fontSize={14} color={baseColors.white}>
                    {`Échéance : le ${props.deadline ? reminderDateTime : ""}`}
                </OpenSansText>

                <Spacer height={10} />

                <OpenSansText fontSize={14} color={baseColors.white}>
                    {`Récurrence : ${isEmptyArray ? "1" : props?.recurrence?.recurrenceDays?.length} fois ${
                        props?.recurrence?.frequency === 1
                            ? props?.recurrence?.frequencyUnit != "once"
                                ? "par"
                                : ""
                            : props?.recurrence?.frequencyUnit === "day" || props?.recurrence?.frequencyUnit === "an"
                            ? " tous les  " + props?.recurrence?.frequency
                            : "toutes les " + props?.recurrence?.frequency
                    } ${getRecurrence(props?.recurrence?.frequencyUnit, props?.recurrence?.frequency)}`}
                </OpenSansText>
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: { padding: 15, borderRadius: 10, marginVertical: 5 },
    iconContainer: { borderRadius: 10, padding: 10, backgroundColor: baseColors.white },
    titleContainer: {
        paddingStart: 10,
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row"
    }
})
